import gql from 'graphql-tag';

export const REOPEN_DEAL = gql`
  mutation ReopenDeal($input: ReopenDealInput!) {
    bpf {
      result: reopenDeal(input: $input) {
        success
        error
      }
    }
  }
`;
